import { Command } from '@/app/common/base/command'
import { Theme } from '@/app/theme/entities/theme.entity'
import { jwtDecode, JwtPayload } from "jwt-decode"
import store from "@/plugins/store"

interface PortalJwtPayload extends JwtPayload {
    apiId: string
}

function getApiIdFromToken(token: string|undefined): string|undefined {
    if (token === undefined) {
        return undefined
    }

    return (jwtDecode(token) as PortalJwtPayload).apiId
}

export class GetThemeCommand extends Command {
    public async run(): Promise<Theme> {
        const apiId = getApiIdFromToken(store.state.auth?.accessToken)
        const response = await this.client.get('/api/theme', { params: { apiId } })
        return response.asEntity(Theme)
    }
}
